import TasksnNotes from "./images/TasksnNotes.jpg"
import Neutrino from "./images/neutreno.jpg"

const productData = [
    {
        title: "Life Assist",
        image: TasksnNotes,
        caption: "Android app for taking notes and priorties tasks quick and easy"
    },

    {
        title: "Neutrino",
        image: Neutrino,
        caption: "ORC tool running on spring boot server and mobile"
    },
]

export default productData